"use client";

import type { Metadata } from "next";
import "./globals.css";
import { Provider } from "react-redux";
import { store, persistor } from "@/redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { CssBaseline } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import Head from "next/head";
import { useEffect } from "react";
import "../lib/aws-config";
import Clarity from "@microsoft/clarity";
import React, { Suspense } from "react";
import Loader from "@/components/core/Loader";
import { Toaster } from "react-hot-toast";
const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#00b073",
    },
  },
});

const metadata: Metadata = {
  title: "Paraacrypto",
  description: "Paraacrypto",
};

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  // useEffect(() => {
  //   const projectId = "qwoscv6bij";
  //   if (typeof window !== "undefined") {
  //     Clarity.init(projectId);
  //   }
  // }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.$zoho = window.$zoho || {};
      window.$zoho.salesiq = window.$zoho.salesiq || { ready: function () {} };

      const script = document.createElement("script");
      script.id = "zsiqscript";
      script.src =
        "https://salesiq.zohopublic.in/widget?wc=siqa18502b7527baea4b055ec057ba26c1ad288576446e507d532ba820a840f93fc";
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);
  return (
    <html lang="en">
      <Head>
        <link rel="stylesheet" href="https://fonts.cdnfonts.com/css/satoshi" />
        <link href="https://fonts.cdnfonts.com/css/quantico" rel="stylesheet" />
        <link href="https://fonts.cdnfonts.com/css/outfit" rel="stylesheet" />
        <title>Paraacrypto | Virtual Crypto Trading Platform</title>
        <meta
          name="description"
          content="Paraacrypto is a virtual trading platform where users can learn crypto trading without risking real money. Join competitions, build portfolios, and master the market!"
        />
      </Head>
      <body>
        <Suspense fallback={<Loader />}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              {/* <ThemeProvider theme={darkTheme}> */}
              <Toaster
                position="top-right"
                toastOptions={{
                  style: {
                    background: "#333",
                    color: "#fff",
                  },
                }}
              />
              <CssBaseline />
              {/* <TopLabel /> */}
              {children}
              {/* <Footer /> */}
              {/* </ThemeProvider> */}
            </PersistGate>
          </Provider>
        </Suspense>
      </body>
    </html>
  );
}
